import { render, staticRenderFns } from "./nutritionistSelect.vue?vue&type=template&id=9513820a"
import script from "./nutritionistSelect.vue?vue&type=script&lang=js"
export * from "./nutritionistSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports